import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"wifi-no-filled"},"children":[{"tag":"g","attrs":{"id":"Union"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 8.5V1H11V8.5H13Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13.0039 10H11V12.0039H13.0039V10Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1.37875 6.725C3.64856 4.90458 6.27649 3.75138 9 3.26544V14H15V3.26526C17.7237 3.75108 20.3519 4.90427 22.6219 6.72487L23.401 7.34975L12.0003 21.6008L0.599609 7.34989L1.37875 6.725Z"}}]}]}]};

const WifiNoFilled = Vue.extend<IconProps>({
  name: 'WifiNoFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'wifi-no-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default WifiNoFilled;
